// extracted by mini-css-extract-plugin
export var button = "horizontalControls-module--button--3ecdb";
export var controls = "horizontalControls-module--controls--56f84";
export var inactive = "horizontalControls-module--inactive--0aa2f";
export var left = "horizontalControls-module--left--26aeb";
export var right = "horizontalControls-module--right--2c552";